import React from 'react';
import { MenuItem, Card, CardHeader, CardText, CardActions, RaisedButton, CircularProgress } from 'material-ui';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import { browserHistory } from 'react-router';
import { TextField, SelectField } from 'redux-form-material-ui';
import { presence, minLength } from 'dash-front/helpers/validation';
import { createAccount } from 'dash-front/admin/actions/accounts';
import PermissionForm from './forms/PermissionsForm';

const clients = Object.keys(require('../../../../../config/clients/specs'));

const USER_TYPES = ['club', 'league', 'media'];

class CreateAccount extends React.PureComponent {
    componentWillReceiveProps({ submitSucceeded }) {
        if (this.props.submitting && submitSucceeded) {
            browserHistory.push('/admin/accounts');
        }
    }

    render() {
        const { submit, submitting } = this.props;
        return (
            <Card>
                <CardHeader title="Creating user" />
                <CardText>
                    <div>
                        <Field
                            name="email"
                            type="email"
                            validate={presence}
                            floatingLabelText="Email"
                            component={TextField}
                        />
                    </div>
                    <div>
                        <Field name="username" validate={presence} floatingLabelText="Username" component={TextField} />
                    </div>
                    <div>
                        <Field name="client" validate={presence} floatingLabelText="Client" component={SelectField}>
                            {clients.map(client => <MenuItem value={client} key={client} primaryText={client} />)}
                        </Field>
                    </div>
                    <div>
                        <Field name="type" validate={presence} floatingLabelText="User type" component={SelectField}>
                            {USER_TYPES.map(type => <MenuItem value={type} key={type} primaryText={type} />)}
                        </Field>
                    </div>
                    <div>
                        <Field
                            name="password"
                            validate={minLength(6)}
                            floatingLabelText="Password"
                            component={TextField}
                        />
                    </div>
                    <div>
                        <h4>Features</h4>
                        <PermissionForm />
                    </div>
                </CardText>
                <CardActions>
                    <RaisedButton
                        onTouchTap={submit}
                        disabled={submitting}
                        icon={submitting ? <CircularProgress size={20} /> : undefined}
                        primary
                        label="Create"
                    />
                </CardActions>
            </Card>
        );
    }
}

const onSubmit = (value, dispatch) => {
    return dispatch(createAccount(value)).then(({ body, status }) => {
        if (status === 400) {
            throw new SubmissionError(body);
        }
    });
};

export default reduxForm({ form: 'createAccount', onSubmit })(CreateAccount);



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Account/CreateAccount.js
 **/